import styled from 'styled-components';

interface OverlayProps {
	$isOpen: boolean;
	$background?: string;
	$zIndex?: number;
	$scrollable?: boolean | string;
}

export const Overlay = styled.div<OverlayProps>`
	display: ${props => (!props.$isOpen ? 'none' : 'flex')};
	position: absolute;
	height: 100%;
	width: 100%;
	max-height: 100dvh;
	max-width: 100vw;
	background: ${props => props.$background || '#3b423bcc'};
	z-index: ${props => props.$zIndex || 999};
	box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 24px;
  padding-bottom: 24px;

  &#booking-form:has(~#person-modal),
  &#person-modal~#booking-form {
    z-index: ${props => props.$zIndex ? props.$zIndex-2 : 997};
  }

  &#booking-form {
    overflow: hidden;
    padding-top: 0;
    padding-bottom: 0;
  }
`;

export const CloseButton = styled.div`
	position: absolute;
	bottom: 95vh;
	right: 2vh;
`;

export const ModalContent = styled.div`
	margin: auto;
`;
